"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePersonRequest = void 0;
var UpdatePersonRequest;
(function (UpdatePersonRequest) {
    let gender;
    (function (gender) {
        gender["MALE"] = "male";
        gender["FEMALE"] = "female";
        gender["NOT_SPECIFIED"] = "not_specified";
    })(gender = UpdatePersonRequest.gender || (UpdatePersonRequest.gender = {}));
})(UpdatePersonRequest || (exports.UpdatePersonRequest = UpdatePersonRequest = {}));
